import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import LeaderboardViews from "../components/LeaderboardViews";
import LeaderboardFlame from "../components/LeaderboardFlame";
import "./LeaderboardPage.css";
import { t } from "../i18n";
import { T } from "../i18n/T";

// Dedicated leaderboard page — for links and direct visits (the Profile tab
// opens the same views in a sheet since 1.5.2 b48: ProfilePage). The views
// themselves: components/LeaderboardViews.

const LeaderboardPage: React.FC = () => {
  const navigate = useNavigate();
  // Same rationale as PayoutHistoryPage: navigation keeps the previous
  // page's scroll, which would hide the page top under the sticky header.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    /* The page owns its scroll — see .djlb-scroll. The fan twin of this board
       (FanLeaderboardPage) is wrapped by .fanlb-scroll for the same reason. */
    <div className="djlb-scroll">
    <div className="leaderboard-page">
      <div className="leaderboard-topbar">
        <button
          type="button"
          className="leaderboard-back"
          // Usually arrived from the Profile drawer's Leaderboard row → back
          // restores that drawer over the original tab. Direct/deep loads have
          // no entry below, so open the drawer over Requests instead.
          onClick={() =>
            (window.history.state?.idx ?? 0) > 0
              ? navigate(-1)
              : navigate("/requests#profile", { replace: true })
          }
          aria-label={t("leaderboardPage.backToMyProfile")}
        >
          <FaArrowLeft size={16} />
        </button>
        <h1 className="leaderboard-title">
          {/* The drawn flame stands in for the 🔥 the copy carries (founder pick A, build 44). */}
          <T k="leaderboardPage.requestAppLeaderboard" tags={{ 0: () => <LeaderboardFlame size={24} /> }} />
        </h1>
      </div>

      <LeaderboardViews />
    </div>
    </div>
  );
};

export default LeaderboardPage;
